import { ROUTE } from "../../../routes";
import { BorderRadiusTokens, ButtonTypeTokens, ColorTokens, SizeTypeTokens } from "@voltmoney/schema";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
import { MutualAmountValueToBackend, MutualFundAmountSelected } from "./types";
let payloadValue;
export const selectTheValueSelected = async (action, datastore, { network, navigate, analytics, setDatastore }) => {
    payloadValue = action?.payload?.value;
    await borderColor(payloadValue, setDatastore);
    await setDatastore(ROUTE.ASK_MUTUAL_FUND, "continueButton", {
        type: ButtonTypeTokens.LargeFilled
    });
};
const mutualFundValue = (value) => {
    switch (value) {
        case MutualFundAmountSelected.TEN_TO_FIFTY_K:
            return MutualAmountValueToBackend.AMOUNT_10K_50K;
        case MutualFundAmountSelected.FIFTY_TO_TWO_LAKH:
            return MutualAmountValueToBackend.AMOUNT_50K_2L;
        case MutualFundAmountSelected.TWO_TO_TEN_LAKH:
            return MutualAmountValueToBackend.AMOUNT_2L_10L;
        case MutualFundAmountSelected.MORE_THAN_TEN_LAKH:
            return MutualAmountValueToBackend.AMOUNT_ABOVE_10L;
        case MutualFundAmountSelected.NO_MUTUAL_FUND:
            return MutualAmountValueToBackend.AMOUNT_0K;
        default:
            return MutualAmountValueToBackend.AMOUNT_0K;
    }
};
const analyticsForMutualFundValue = (value, analytics) => {
    switch (value) {
        case MutualFundAmountSelected.TEN_TO_FIFTY_K:
            return analytics("portfolio_10k_50k", { "event": "portfolio_10k_50k" });
        case MutualFundAmountSelected.FIFTY_TO_TWO_LAKH:
            return analytics("portfolio_50k_2l", { "event": "portfolio_50k_2l" });
        case MutualFundAmountSelected.TWO_TO_TEN_LAKH:
            return analytics("portfolio_2l_10L", { "event": "portfolio_2l_10L" });
        case MutualFundAmountSelected.MORE_THAN_TEN_LAKH:
            return analytics("portfolio_more_than_10", { "event": "portfolio_more_than_10" });
        case MutualFundAmountSelected.NO_MUTUAL_FUND:
            return analytics("portfolio_no", { "event": "portfolio_no" });
        default:
            return analytics("portfolio_no", { "event": "portfolio_no" });
    }
};
const borderColor = async (value, setDatastore) => {
    await setDatastore(ROUTE.ASK_MUTUAL_FUND, "tenToFiftyStack", {
        borderConfig: {
            borderRadius: BorderRadiusTokens.BR2,
            borderWidth: {
                all: SizeTypeTokens.XS
            },
            borderColor: value === MutualFundAmountSelected.TEN_TO_FIFTY_K ? ColorTokens.Primary_100 : ColorTokens.Grey_Chalk,
        },
    });
    await setDatastore(ROUTE.ASK_MUTUAL_FUND, "tenToFiftyText", {
        color: value === MutualFundAmountSelected.TEN_TO_FIFTY_K ? ColorTokens.Primary_100 : ColorTokens.Grey_Night
    });
    await setDatastore(ROUTE.ASK_MUTUAL_FUND, "fiftyToTwoLakhText", {
        color: value === MutualFundAmountSelected.FIFTY_TO_TWO_LAKH ? ColorTokens.Primary_100 : ColorTokens.Grey_Night
    });
    await setDatastore(ROUTE.ASK_MUTUAL_FUND, "twoToTenLakhText", {
        color: value === MutualFundAmountSelected.TWO_TO_TEN_LAKH ? ColorTokens.Primary_100 : ColorTokens.Grey_Night
    });
    await setDatastore(ROUTE.ASK_MUTUAL_FUND, "moreThanTenLakhText", {
        color: value === MutualFundAmountSelected.MORE_THAN_TEN_LAKH ? ColorTokens.Primary_100 : ColorTokens.Grey_Night
    });
    await setDatastore(ROUTE.ASK_MUTUAL_FUND, "noMutualFundText", {
        color: value === MutualFundAmountSelected.NO_MUTUAL_FUND ? ColorTokens.Primary_100 : ColorTokens.Grey_Night
    });
    await setDatastore(ROUTE.ASK_MUTUAL_FUND, "fiftyToTwoLakhStack", {
        borderConfig: {
            borderRadius: BorderRadiusTokens.BR2,
            borderWidth: {
                all: SizeTypeTokens.XS
            },
            borderColor: value === MutualFundAmountSelected.FIFTY_TO_TWO_LAKH ? ColorTokens.Primary_100 : ColorTokens.Grey_Chalk,
        },
    });
    await setDatastore(ROUTE.ASK_MUTUAL_FUND, "twoToTenLakhStack", {
        borderConfig: {
            borderRadius: BorderRadiusTokens.BR2,
            borderWidth: {
                all: SizeTypeTokens.XS
            },
            borderColor: value === MutualFundAmountSelected.TWO_TO_TEN_LAKH ? ColorTokens.Primary_100 : ColorTokens.Grey_Chalk,
        },
    });
    await setDatastore(ROUTE.ASK_MUTUAL_FUND, "moreThanTenLakhStack", {
        borderConfig: {
            borderRadius: BorderRadiusTokens.BR2,
            borderWidth: {
                all: SizeTypeTokens.XS
            },
            borderColor: value === MutualFundAmountSelected.MORE_THAN_TEN_LAKH ? ColorTokens.Primary_100 : ColorTokens.Grey_Chalk,
        },
    });
    await setDatastore(ROUTE.ASK_MUTUAL_FUND, "noMutualFundStack", {
        borderConfig: {
            borderRadius: BorderRadiusTokens.BR2,
            borderWidth: {
                all: SizeTypeTokens.XS
            },
            borderColor: value === MutualFundAmountSelected.NO_MUTUAL_FUND ? ColorTokens.Primary_100 : ColorTokens.Grey_Chalk,
        },
    });
};
export const continueButtonAction = async (action, datastore, { network, navigate, analytics }) => {
    const selectedMutualFund = mutualFundValue(payloadValue);
    const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
    const userId = userContextResponse.data.user.userId;
    await network.patch(`${api.userAttributes}${userId}`, {
        assetRange: selectedMutualFund
    }, { headers: await getAppHeader() });
    if (selectedMutualFund !== MutualAmountValueToBackend.AMOUNT_0K) {
        await network.post(`${api.saveSecurityConsent}${userId}`, {
            consent: "YES"
        }, { headers: await getAppHeader() });
        await navigate(ROUTE.EMAIL_VERIFY);
    }
    else {
        await network.post(`${api.saveSecurityConsent}${userId}`, {
            consent: "NO"
        }, { headers: await getAppHeader() });
        await navigate(ROUTE.NO_MUTUAL_FUND_INSTRUCTION);
    }
    analyticsForMutualFundValue(payloadValue, analytics);
};
